__turbopack_context__.v({
  "cell": "CheckAppConnectionCell-module__tfi7xW__cell",
  "root": "CheckAppConnectionCell-module__tfi7xW__root",
});
